var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import Command from '../Command';
import confirmRegistration from '../../requests/authentication/confirmRegistration';
import Session from '../../services/Session';
import History from '../../services/History';
import Routes from '../../routes/RoutesConfig';
import GetCurrentUserCommand from '../users/GetCurrentUserCommand';
import Signals from '../../signals/Signals';
/**
 *
 */
var ConfirmRegistrationCommand = /** @class */ (function (_super) {
    __extends(ConfirmRegistrationCommand, _super);
    function ConfirmRegistrationCommand() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * @param token
     * @param intl
     */
    ConfirmRegistrationCommand.prototype.execute = function (token, intl) {
        this.intl = intl;
        //
        var promise = confirmRegistration(token);
        promise.then(this.then);
        promise.catch(this.catch);
        return promise;
    };
    /**
     *
     * @param response
     */
    ConfirmRegistrationCommand.prototype.then = function (response) {
        Session.setJWT(response.jwt);
        Signals.ShowNotification.dispatch(this.intl.formatMessage({ id: 'notification.confirmemail.confirmed' }), 'dark');
        var command = new GetCurrentUserCommand();
        command.execute().then(function () {
            if (Session.user.requiresOnBoarding) {
                History.push(Routes.ON_BOARDING.path);
            }
            else {
                History.push(Routes.ASSETS.path);
            }
        });
    };
    ConfirmRegistrationCommand.prototype.catch = function (error) {
    };
    return ConfirmRegistrationCommand;
}(Command));
export default ConfirmRegistrationCommand;
